Promise.all([import('scripts/marmalade/classes/video-embed'), import('scripts/marmalade/classes/background-video')]).then(_ref => {
  let [moduleVideoEmbed, moduleBackgroundVideo] = _ref;
  // Define the components
  const VideoEmbed = moduleVideoEmbed.default;
  const BackgroundVideo = moduleBackgroundVideo.default;

  // Find the banner & slider
  const banner = document.querySelector('.js-banner');
  const content = banner.querySelector('.js-banner__content');
  const slider = banner.querySelector('.js-banner__slider');
  const slides = [...slider.children];
  // Store our videos here
  const videos = [];

  // Find the pagination holder before we find the buttons
  let pagination = banner.querySelector('.js-banner__pagination');
  const loadVideo = function () {
    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (window.innerWidth >= 1024) {
      videos.forEach(video => {
        if (video.container == slides[index]) {
          video.holder.appendChild(video.iframe.element);
          video.iframe.resize();
        } else {
          try {
            video.iframe.element.classList.remove('video-loaded');
            video.holder.removeChild(video.iframe.element);
          } catch (err) {}
        }
      });
    }
  };
  if (pagination) {
    // Get the pagination buttons
    pagination = [...pagination.children];
    // Attach click event listeners to all pagination buttons
    pagination.forEach((button, index) => {
      button.addEventListener('click', () => {
        // Remove 'active' class from all buttons
        pagination.forEach(btn => btn.classList.remove('active'));
        slides.forEach(slide => slide.classList.remove('active'));
        pagination[index].classList.add('active');
        slides[index].classList.add('active');
      });
    });
  }
  content.style.minHeight = content.clientHeight + 'px';
  window.addEventListener('scripts-loaded', () => {
    slides.forEach((slide, index) => {
      // // Find a video if there is one
      const video = slide.querySelector('[data-background-video]') || false;

      // If we have a video
      if (video) {
        // Create a video embed
        const embed = new VideoEmbed(video.getAttribute('data-background-video'), {
          mute: 1,
          loop: 1
        });
        const data = {
          container: slide,
          holder: video,
          index: index,
          iframe: new BackgroundVideo(embed.iframe)
        };
        const observer = new ResizeObserver(() => data.iframe.resize());
        observer.observe(video);
        videos.push(data);
        if (index === 0) loadVideo(index);
      }
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});